import clsx from "clsx";

type Props = {
  id?: string;
  on: boolean;
  withBorder?: boolean;
  onChange: () => void;
  className?: string;
};

export default function Switcher({ id, on, onChange, withBorder, className }: Props) {
  return (
    <button
      id={id}
      type="button"
      className={clsx(
        "w-fit",
        withBorder ? "border border-dark-800/50 rounded-[6px] p-1" : "",
        className,
      )}
      onClick={onChange}
    >
      <div
        className={clsx(
          "flex w-[32px] h-[16px] rounded-[4px] transition-all",
          on ? "bg-[#84FF97]/10" : "bg-[#433B43]/10",
        )}
      >
        <div
          className={clsx(
            "h-full aspect-square rounded-[4px] transition-all",
            on ? "bg-[#84FF97] translate-x-4" : "bg-[#433B43]",
          )}
        />
      </div>
    </button>
  );
}
